import React from "react";
import { Table, Row, Col, Card, Badge } from "react-bootstrap";
import DateRenderer from "./renderers/DateRenderer";

interface DegreeAuditViewProps
{
    data: DegreeAudit;
}

export default class DegreeAuditView extends React.Component<DegreeAuditViewProps>
{
    render(): React.ReactNode 
    {
        return <div>
            <h2>Degree Audit</h2>
            {
                (this.props.data && this.props.data.degreeAuditInfo)
                    ?
                    <Card className={"border"}>
                        <Card.Body>
                            <Row style={{ marginTop: "10px", marginBottom: "10px" }}>
                                <Col sm={6}>
                                    <h5><b>Projected</b> <Badge pill variant={"light"}><DateRenderer type={"long"} value={this.props.data.degreeAuditInfo.projected.date} /></Badge></h5>
                                    <Table responsive className="dictionary" style={{ width: "auto" }} borderless>
                                        <tbody>
                                            {
                                                this.props.data.degreeAuditInfo.projected.auditInfoList.map((itm, i) =>
                                                {
                                                    return <tr key={i}>
                                                        <td>{itm.auditStringText}</td>
                                                    </tr>;
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </Col>
                                <Col sm={6}>
                                    <h5><b>Actual</b> <Badge pill variant={"light"}><DateRenderer type={"long"} value={this.props.data.degreeAuditInfo.actual.date} /></Badge></h5>
                                    <Table responsive className="dictionary" style={{ width: "auto" }} borderless>
                                        <tbody>
                                            {
                                                this.props.data.degreeAuditInfo.actual.auditInfoList.map((itm, i) =>
                                                {
                                                    return <tr key={i}>
                                                        <td>{itm.auditStringText}</td>
                                                    </tr>;
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    :
                    <div className="text-center" id='error'>
                        <br />
                        <p className="error-text">No Degree Audit data available</p>
                    </div>
            }
        </div>;
    }
}